import type { GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS } from './constants.tsx';
import { PubSubHub } from './pub-sub-hub/index.tsx';
import type { PubSub, Subscriber } from './pub-sub-hub/types.tsx';

const GICLifeCycleEventsService: PubSub<GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS> =
	new PubSubHub<GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS>();

export const useGICLifeCycleEvents = (): {
	subscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => () => void;
	unsubscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => void;
	publish: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		payload: GIC_LIFECYCLE_EVENTS_PAYLOADS[Event],
	) => void;
	clearAll: () => void;
} => ({
	...GICLifeCycleEventsService,
});
